<mat-sidenav-container autosize>
  <mat-sidenav mode="side" opened fixedInViewport>
    <vitamui-common-select-language class="d-flex justify-content-center my-3"></vitamui-common-select-language>
    <form [formGroup]="form">
      <vitamui-select
        class="d-flex my-3 mx-1"
        [options]="searchOptions"
        [placeholder]="'MENU.FIND.PLACEHOLDER' | translate"
        [searchBarPlaceHolder]="'MENU.FIND.SEARCH_BAR_PLACEHOLDER' | translate"
        formControlName="search"
      ></vitamui-select>
    </form>
    <mat-list>
      <ng-template #accordion let-routes let-parents="parents">
        <mat-accordion>
          @for (route of routes; track route.path) {
            @if (route.path) {
              <mat-expansion-panel
                [hideToggle]="!route.children?.length"
                [expanded]="isActive('/' + (parents ? parents.join('/') + '/' : '') + route.path)"
              >
                <mat-expansion-panel-header
                  routerLink="/{{ (parents ? parents.join('/') + '/' : '') + route.path }}"
                  routerLinkActive="active"
                  >{{ 'ROUTE.' + (parents ? parents.join('.') + '.' : '') + route.path + '.TITLE' | translate }}
                </mat-expansion-panel-header>
                @for (child of route.children; track child.path) {
                  @if (child.children) {
                    <ng-container
                      *ngTemplateOutlet="accordion; context: { $implicit: [child], parents: (parents || []).concat([route.path]) }"
                    ></ng-container>
                  } @else if (child.path) {
                    <a
                      routerLink="/{{ (parents ? parents.join('/') + '/' : '') + route.path + '/' + child.path }}"
                      routerLinkActive="active"
                      >{{ 'ROUTE.' + (parents ? parents.join('.') + '.' : '') + route.path + '.' + child.path + '.TITLE' | translate }}</a
                    >
                  }
                }
              </mat-expansion-panel>
            }
          }
        </mat-accordion>
      </ng-template>

      <ng-container *ngTemplateOutlet="accordion; context: { $implicit: routes }"></ng-container>
    </mat-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <div>
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
